import React from 'react';
import { Link } from 'react-router-dom'
import PageTitle from '../../../shared/javascripts/components/PageTitle/PageTitle'
 
const Dashboard = (props) => {
  const {match} = props;

  return(
    <div className="Dashboard">
      <PageTitle title='Dashboard' /><hr />
      <ul className='nav nav-pills nav-stacked'>
        <li><Link to={`${match.url}/users`}>Users</Link></li>
        <li><Link to={`${match.url}/statistics`}>Statistics</Link></li>
        <li><Link to={`${match.url}/activity_logs`}>Activity Logs</Link></li>
        <li><Link to={`${match.url}/statuses`}>Status Page</Link></li>
      </ul>
    </div>
  )
}

export default Dashboard


// WEBPACK FOOTER //
// ./src/manager/javascripts/components/Dashboard.jsx